import { AtendimentoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type EspecialidadesFilters = {
  /** Nome da especialidade (busca parcial). */
  nome: string
  tipoAtendimento?: IOption<AtendimentoType>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<EspecialidadesFilters>({
  nome: '',
  tipoAtendimento: undefined,
})
